'use client';

import { atom } from 'jotai';

import { CountryCode } from '../../Entities/CountryCode/CountryCode.entity';

export const countryCodesAtom = atom<CountryCode[]>([
  {
    value: 'DE',
    shortLabel: '+49',
    label: 'Deutschland (+49)',
  },
]);
